import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { Copy } from '@src/components/Copy';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { trackEvent, trackOpeningSocialShare } from '@src/metrics';
import FacebookSvg from '@src/svgs/social/facebook.svg';
import LinkedinSvg from '@src/svgs/social/linkedin.svg';
import TwitterSvg from '@src/svgs/social/twitter.svg';
import './styles.scss';

export const ShareOpening = ({ openingUrl, openingId }) => {
  return (
    <div className="share">
      <h4 className="share__header-title">Share opening</h4>

      <div className="share__content">
        <div className="share__url">
          <p className="share__title">Opening link</p>

          <p className="share__text share__text--margin">Share this opening publicly by copying the URL below</p>

          <Copy
            onCopy={() =>
              trackEvent({
                context: MetricContext.OPENING_SHARING,
                interaction: MetricAction.COPY_PUBLIC_URL,
                payload: {
                  'Event Source': MetricEventSource.COPY_LINK_BUTTON_OPENING_SHARING_SECTION,
                  'Opening Id': openingId,
                  'Previous Context': MetricContext.OPENING_VIEW,
                },
              })
            }
            text={openingUrl}
          />
        </div>
        <div className="share__social">
          <div>
            <p className="share__title">Share</p>

            <p className="share__text">Share this opening on social networks</p>
          </div>
          <div className="share__buttons">
            <TwitterShareButton url={openingUrl}>
              <Svg onClick={() => trackOpeningSocialShare({ openingId, platform: 'Twitter' })} src={TwitterSvg} />
            </TwitterShareButton>

            <FacebookShareButton url={openingUrl}>
              <Svg onClick={() => trackOpeningSocialShare({ openingId, platform: 'Facebook' })} src={FacebookSvg} />
            </FacebookShareButton>

            <LinkedinShareButton url={openingUrl}>
              <Svg onClick={() => trackOpeningSocialShare({ openingId, platform: 'Linkedin' })} src={LinkedinSvg} />
            </LinkedinShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

ShareOpening.propTypes = {
  openingId: PropTypes.string.isRequired,
  openingUrl: PropTypes.string.isRequired,
};
